import { ListItem, ListItemAvatar, Avatar, ListItemText } from "@mui/material";

interface Props {
  icon: JSX.Element;
  onArrowClick: () => void;
  primaryText: string;
  secondaryText: string;
}

const ListItemMobile = ({ icon, onArrowClick, primaryText, secondaryText }: Props) => (
  <ListItem sx={{ display: { xs: "flex", md: "none" } }} onClick={onArrowClick}>
    <ListItemAvatar>
      <Avatar>{icon}</Avatar>
    </ListItemAvatar>
    <ListItemText primary={primaryText} secondary={secondaryText} />
  </ListItem>
);

export default ListItemMobile;
